import Image from "next/image";

const ExpectationsSectionBottomContent = () => {
  return (
    <div className="flex flex-col-reverse md:grid md:grid-cols-12">
      <div className="mt-8 md:mt-0 md:col-span-6">
        <div
          className="min-h-[200px] xs:min-h-[400px] md:min-h-[560px] h-full w-full bg-cover bg-left md:bg-center bg-no-repeat
          rounded-xl md:rounded-tl-none md:rounded-bl-none md:rounded-tr-xl md:rounded-br-xl"
          style={{
            backgroundImage: "url('/images/partners/expectations-03.png')",
          }}
        />
      </div>
      <div className="md:col-span-6 md:p-12 lg:p-24 flex items-center justify-start">
       <div className="lg:max-w-[528px] flex flex-col items-start justify-center space-y-4">
       <Image
          src="/assets/icons/mdi-account-multiple.png"
          alt="Creative Synergies"
          height={40}
          width={40}
        />
        <span className="mobile-h4 md:h5 lg:h4 text-text-color-high-em">Creative Synergies</span>
        <span className="text-text-color-mid-em">
          At SimpleWaste we employ principal strategies that support a unified
          purpose. These strategies are carefully designed through market
          research, technology integrations, creative structuring, and
          synergistic campaigns. ​
        </span>
       </div>
      </div>
    </div>
  );
};

export default ExpectationsSectionBottomContent;
